import lineChart from "./LineChart";
import closeLineChart from "./CloseLineChart";
import barChart from "./BarChart";
import barLineChart from "./BarLineChart";
import pieChart from "./PieChart";
import gaugeChart from "./GaugeChart";
import scatterChart from "./ScatterChart";
import pieceScatterChart from "./ScatterChart2";
import polarBarChart from "./PolarBarChart";
import pictorialBarChart from "./PictorialBarChart";
import rectStackBarChart from "./RectStackBarChart";
import RadarChart from "./RadarChart";
import LineMarkPointChart from "./LineMarkPointChart";
import oscilloscope from './Oscilloscope';
import singleRing from "./SingleRingChart";
import animatePieChart from "./AnimatePieChart";
import funnelChart from "./FunnelChart";

import GpParser from "../../gpParser";
import { CATEGORIES } from "../../configuration/constants";
import bidirectionalBarChart from "./BidirectionalBarChart";
import doubleRingChart from "./DoubleRingChart";
import GanteChart from './GanteChart';

export default (editor, options) => {
  GpParser.loadFromList(
    [
      lineChart,
      LineMarkPointChart,
      closeLineChart,
      barChart,
      barLineChart,
      pictorialBarChart,
      rectStackBarChart,
      polarBarChart,
      pieChart,
      scatterChart,
      pieceScatterChart,
      gaugeChart,
      RadarChart,
      bidirectionalBarChart,
      doubleRingChart,
      oscilloscope,
      singleRing,
      animatePieChart,
      funnelChart,
      GanteChart
    ],
    CATEGORIES.ECHARTS,
    editor,
    options
  );
};
